import type { ReactElement } from 'react';

interface AppIconProps {
    type: string;
    color?: string;
    size?: string;
    className?: string;
    backgroundSize?: number;
}

const AppIcon = (props: AppIconProps): ReactElement => {
    const { type, color = 'black', size = '14', className, backgroundSize } = props;

    const textColor = backgroundSize ? `white bg-${color} border-radius-100pct padding-${backgroundSize}` : color;

    const classes = `uikit-icon icon-${type} text-color-${textColor} text-size-${size} ${className ? className : ''}`;

    return <span className={classes} data-testid={`app-icon-${type}`} />;
};

export default AppIcon;
